import apiService from './api.service';
import type { AnalysisRuleViolationsResponse, PolicyResponse } from '../types/policy.types';

class PolicyService {
  async getMyPolicy(): Promise<PolicyResponse> {
    const res = await apiService.client.get<PolicyResponse>('/me/policy');
    return res.data;
  }

  async getAnalysisRuleViolations(analysisId: string): Promise<AnalysisRuleViolationsResponse> {
    const res = await apiService.client.get<AnalysisRuleViolationsResponse>(
      `/me/analyses/${analysisId}/rule-violations`,
    );
    return res.data;
  }
}

export default new PolicyService();
